import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { autobind } from 'packages/core/lib';
import {setMetricsEvent} from "../../../actions/metrics";
import Spinner from '../../../components/Spinner';
import Device from '../../../devices/device';
import Translator from '../../../requests/apa/Translator';
import Asset from 'src/requests/apa/Asset';
import {IMatchProps} from './match';
import {MatchRibbon, IMatchRibbonProps, IMatchSeparator} from './matchRibbon';
import { showNotification } from '../../../actions/notification';
import store from '../../../store';
import {getSeparators, getDayOffWeek, getMonthName, isScheduled, getApaAlertAutoHideTime, isTeamPlaceholder} from '../../utls/utils';
import api from './../../requests/api/';
import {cls} from 'packages/components';
import Utils from '../../../utils/Utils';
import {COMPONENT_WORLD_CUP, ACTION_MATCH} from '../../utls/constantsMetrics';
import './_styles.scss';
import { MatchDate } from 'src/mundial/requests/interfaces';
interface IPlanselectorState {
  data: IMatchRibbonProps[];
  isLoading: boolean;
}


declare var window: any;
class Match extends Component<RouteComponentProps & IMatchProps, IPlanselectorState> {
  public keys = Device.getDevice() && Device.getDevice().getKeys() || null;
  /**
   * @var device
   * added device platform only in this case (androidtv)
   */
  private device = '';
  
  constructor(props: RouteComponentProps & IMatchProps) {
    super(props);
    this.state = {
      isLoading: true,
      data: [{
        matches: [],
        roundId: '',
        index: 0,
        phaseName: '',
        separator : {
          pipe: '',
          versus: '',
          hyphen : ''
        }
      }]
    };
    this.keys = Device.getDevice().getKeys();
    this.device = Device.getDevice().getPlatform();
  }

  componentDidMount() {
    this.getApiData()
    this.addEventListener();
  }


  private async getApiData():Promise<void> {

    const defaultFlag : string = Asset.get('matches_result_placehoderFlag_img');
    const matchesData = await api.getMatchesByRound();

    const data: IMatchRibbonProps[] = matchesData.map((match)=>{
      const {roundName = '', roundId = '', matches} = match;
      return {
        roundId: roundId,
        index: 0,
        phaseName: roundName,
        separator: getSeparators(),
        matches: matches.map((match, indexMatch, array ): IMatchProps=>{
          const {date,
            homeTeam:{name : homeName = '', flag: homeFlag = ''} ={},
            awayTeam:{name : awayName = '', flag: awayFlag = ''} ={},
            score: {homeScore, awayScore} = {},
            status,
            id
          } = match;
          const isLocalPlaceholder = isTeamPlaceholder(match.homeTeam || {});
          const isVisitorPlaceholder = isTeamPlaceholder(match.awayTeam || {});
          const imageSrcLocal = isLocalPlaceholder ? defaultFlag : homeFlag;
          const imageSrcVisitor = isVisitorPlaceholder ? defaultFlag: awayFlag;
          let navigation: any = {};

          if (indexMatch === (array.length - 1)) {
               navigation['data-sn-right'] = id;
          }

          return {
            id,
            row: 0,
            column: 0,
            title: this.getMatchResultText(status),
            subtitle: date.weekday,
            matchDate: this.formatMatchDate(date, getSeparators(), Translator.get('match_detail_hourAbbreviation_label','hs')),
            separator: getSeparators(),
            localTeam:{
              name:homeName,
              imageSrc:imageSrcLocal,
              score:homeScore?.toString(),
              isPlaceholder: isTeamPlaceholder(match.homeTeam || {})
            },
            visitorTeam :{
              name:awayName,
              imageSrc: imageSrcVisitor,
              score: awayScore?.toString(),
              isPlaceholder: isTeamPlaceholder(match.awayTeam || {})
            },
            onClick: ()=> this.handleClick(match),
            navigation
          }
        })
      }
    });

    this.setState({isLoading:false, data})
  }



  private getMatchResultText(status: string): string {
     const metadataText = {
      "COMPLETED": Translator.get('matches_result_finalized_label','YA EMITIDO'),
      "IN_PROGRESS": Translator.get('matches_result_now_label','AHORA'),
      "SCHEDULED": Translator.get('matches_result_later_label','MÁS TARDE'),
    }

    if (metadataText.hasOwnProperty(status)){
      return metadataText[status as keyof typeof metadataText];
    }
    return '';    
  }


  private formatMatchDate(d : MatchDate, separator: IMatchSeparator, labelHour: string): string{
    const {pipe} = separator;
      return `${d.day} de ${getMonthName(d.month - 1)} ${pipe} ${d.hours}:${d.minutes} ${labelHour}`;
  }

  componentWillUnmount() {
    this.removeEventListener();
  }

  @autobind
  private handleKeyDown(e: KeyboardEvent): void {
  }

  @autobind
  handleBack() {
    const { history } = this.props;
    history.goBack();
  };

  @autobind
  handleClick(data: any) {
    const {status, id: matchid = ''} = data;
    const { history } = this.props;

    this.sendMetric(data);

    switch (status){
      case 'SCHEDULED':
      case 'COMPLETED':
      case 'IN_PROGRESS':

        if (!isScheduled(data)){
          this.showNotification()
          return;
         }
        // Cuando el usuario seleccione una tarjeta se deberá dirigir a la vcard del partido (HU065)
        // https://dlatvarg.atlassian.net/wiki/spaces/RAF/pages/3524886628/EPC-Feature+-+AAF+mundial
        history.push(`/mundial/vcardmatch/${matchid}`);
        break;
    }
  };

  sendMetric(data: any): void{
    //console.log('GCR data is ==>', data)
    const {homeTeam : {name: homeTeamName}, awayTeam:{ name : awayTeamName}} = data;
    const {versus} = getSeparators();
    const label = `${homeTeamName} ${versus} ${awayTeamName}`;
    
    Utils.sendMetric(this.props, ACTION_MATCH, label, COMPONENT_WORLD_CUP);
  }

  showNotification(): void {
    store.dispatch(showNotification({
      show: true,
      title: Translator.get('match_alert_title_teamNotDefined_label'),
      msg: Translator.get('match_alert_description_teamNotDefined_label'),
      type: 'notification',
      timeShowing: getApaAlertAutoHideTime(),
    }));
  }

  addEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  removeEventListener() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  public render(): JSX.Element {
    const { data, isLoading } = this.state;

    if (isLoading) {
      return <Spinner className="worldcup-match-container" loadingMessage='' />
    } else {

      return <div className={cls('worldcup-match-container')}>
        {data.map((ribbon:IMatchRibbonProps, index )=>{
          return <MatchRibbon key={ribbon.roundId} {...ribbon} index={index}/>
        })}
          {/* <div className={cls('worldcup-match-ribbon')}>
          </div> */}
      </div>
  }
}
}

export default connect(null, {setMetricsEvent})(withRouter(Match));



// WEBPACK FOOTER //
// ./src/mundial/Tabs/Match/index.tsx